import type React from 'react'
import { Suspense, lazy } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
} from 'react-router-dom'
import ProgressDisplay from '../components/ProgressDisplay'
import { Dashboard } from '../features/dashboard/Dashboard'
import { ColorModeProvider } from '../design/ColorModeProvider'
import AppShell from './v2/AppShell'
import NotFoundV2 from './v2/NotFoundV2'
import { sessionAnalysisPath } from '../features/sessionAnalysisV2/sessionAnalysisPath'
const TrackSessionAnalysisDashboard = lazy(
  async () => await import('../pages/TrackSessionAnalysisDashboard')
)
const DrawPage = lazy(async () => await import('../pages/DrawPage'))
const VehiclesPage = lazy(async () => await import('../pages/VehiclesPage'))
const UserSuggestedTracksPage = lazy(
  async () => await import('../pages/UserSuggestedTracksPage')
)
const CompareLapsDashboard = lazy(
  async () => await import('../pages/CompareLapsDashboard')
)
const DesignSystemPage = lazy(
  async () => await import('../pages/DesignSystemPage')
)
const SettingsPage = lazy(async () => await import('../pages/SettingsPage'))
const AdminProcessingPage = lazy(
  async () => await import('../features/admin/AdminProcessingPage')
)
const SessionListPage = lazy(
  async () => await import('../features/analyseSession/SessionListPage')
)
const SessionAnalysisPage = lazy(
  async () => await import('../features/sessionAnalysisV2/SessionAnalysisPage')
)

const RedirectToAnalysisSession: React.FC = () => {
  const { sessionId } = useParams()
  return <Navigate to={sessionAnalysisPath([sessionId ?? ''])} replace />
}

const AppRouter: React.FC = () => (
  <BrowserRouter>
    <Suspense fallback={<ProgressDisplay isLoading={true} progress={0} />}>
      <Routes>
        <Route
          path="/design-system"
          element={
            <ColorModeProvider>
              <DesignSystemPage />
            </ColorModeProvider>
          }
        />
        <Route path="/v2" element={<AppShell />}>
          <Route index element={<Navigate to="/v2/analysis" replace />} />
          <Route path="analysis" element={<SessionListPage />} />
          <Route
            path="analysis/telemetry"
            element={<TrackSessionAnalysisDashboard />}
          />
          <Route
            path="analysis/telemetry/:sessionId"
            element={<TrackSessionAnalysisDashboard />}
          />
          <Route path="analysis/sessions" element={<SessionAnalysisPage />} />
          <Route
            path="analysis/sessions/:sessionId"
            element={<SessionAnalysisPage />}
          />
          <Route path="compare" element={<CompareLapsDashboard />} />
          <Route path="vehicles" element={<VehiclesPage />} />
          <Route path="draw-on-track" element={<DrawPage />} />
          <Route
            path="suggested-tracks"
            element={<UserSuggestedTracksPage />}
          />
          <Route
            path="session"
            element={<Navigate to="/v2/analysis" replace />}
          />
          <Route
            path="session/:sessionId"
            element={<RedirectToAnalysisSession />}
          />
          <Route path="admin" element={<AdminProcessingPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<NotFoundV2 />} />
        </Route>
        <Route
          path="/"
          element={
            <Dashboard>
              <TrackSessionAnalysisDashboard />
            </Dashboard>
          }
        />
        <Route
          path="/draw-on-track"
          element={
            <Dashboard>
              <DrawPage />
            </Dashboard>
          }
        />
        <Route
          path="/compare-laps"
          element={
            <Dashboard>
              <CompareLapsDashboard />
            </Dashboard>
          }
        />
        <Route
          path="/vehicles"
          element={
            <Dashboard>
              <VehiclesPage />
            </Dashboard>
          }
        />
        <Route
          path="/suggested-tracks"
          element={
            <Dashboard>
              <UserSuggestedTracksPage />
            </Dashboard>
          }
        />
        <Route
          path="/session"
          element={
            <Dashboard>
              <TrackSessionAnalysisDashboard />
            </Dashboard>
          }
        />
        <Route
          path="/session/:sessionId"
          element={
            <Dashboard>
              <TrackSessionAnalysisDashboard />
            </Dashboard>
          }
        />
      </Routes>
    </Suspense>
  </BrowserRouter>
)

export default AppRouter
